import CustomVideo from './custom-video';
import HeroImage from './hero-image';
import HeroSlider from './hero-slider';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {CUSTOM_HERO_IMAGE, OFFICE_AREA_IMAGE} from '../../../constants/constants';

import './hero-slider.scss';

class HeroContainer extends Component {
  getHeroImageComponent = (imageType) => {
    const siteOptions = this.props.entity.siteOptions || {};
    const entity = this.props.entity;
    return <HeroImage
      heroOptions={siteOptions.heroSliderOptions}
      region={entity.region}
      imageUrl={imageType === CUSTOM_HERO_IMAGE ? siteOptions.heroSliderOptions.customImage : entity.officeAreaImageUrl}/>;
  }

  render() {
    let hero = null;
    const siteOptions = this.props.entity.siteOptions || {};
    const {
      actions,
      entity,
      defaultOptions,
      heroListings,
    } = this.props;
    if (siteOptions.showVideo) {
      hero = <CustomVideo
        heroOptions={siteOptions.heroSliderOptions}
        region={entity.region}/>;
    } else if (siteOptions.heroSliderOptions.showType === CUSTOM_HERO_IMAGE) {
      hero = this.getHeroImageComponent(CUSTOM_HERO_IMAGE);
    } else if (siteOptions.heroSliderOptions.showType === OFFICE_AREA_IMAGE) {
      hero = this.getHeroImageComponent(OFFICE_AREA_IMAGE);
    } else {
      hero = <HeroSlider
        entity={entity}
        backupImage={this.getHeroImageComponent(OFFICE_AREA_IMAGE)}
        defaultOptions={defaultOptions}
        heroListings={heroListings}
        region={entity.region.urlPart}
        saveHeroListings={actions.saveHeroListings}/>;
    }
    return (
      <div className={siteOptions.heroSliderOptions.showHeroMessage ? 'has-hero-message' : ''}>
        {hero}
      </div>
    );
  }
}

HeroContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  entity: PropTypes.object.isRequired,
  defaultOptions: PropTypes.object.isRequired,
  heroListings: PropTypes.array
};

export default HeroContainer;


// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/index.js